import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=5b941c34&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Layout.vue?vue&type=style&index=0&id=5b941c34&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b941c34",
  "381faf37"
  
)

export default component.exports